if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
  if (response.status) {
    const message = this.normalizeErrorMessage(response);
    this.handleErrorMessage(message);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    normalizeErrorMessage(response) {
      // Start with whatever Shopify gives us
      let desc = response && response.description;
      let message = '';

      // Case 1: description is a simple string → use it directly
      if (typeof desc === 'string') {
        message = desc;
      }

      // Case 2: description is an object like { "properties[Recipient email]": "is invalid" }
      else if (desc && typeof desc === 'object') {
        const firstEntry = Object.entries(desc)[0] || [];
        const rawField = firstEntry[0];
        let fieldError = firstEntry[1];

        if (Array.isArray(fieldError)) {
          fieldError = fieldError[0];
        }

        // Try to turn the field key into the actual label text from the form
        const labelText = this.getFieldLabelText(rawField);

        // Normalise error bit – Shopify often sends "is invalid"
        let errorBit =
          typeof fieldError === 'string' && fieldError.trim()
            ? fieldError.trim()
            : 'is invalid';

        // Special-case email to be more helpful
        if (/email/i.test(rawField || '') || /email/i.test(labelText || '')) {
          if (errorBit === 'is invalid') {
            errorBit = 'must be a valid email address';
          }
        }

        // Build final message
        if (labelText) {
          let cleanLabel = labelText.trim();
          cleanLabel = cleanLabel.replace(/\s*\(.*?\)\s*$/, ''); // drop "(optional)"
          cleanLabel = cleanLabel.replace(/[:*]\s*$/, '');       // drop ":" or "*"

          message = `${cleanLabel} ${errorBit}`.trim();
          if (!/[.!?]$/.test(message)) message += '.';
        } else {
          // No label found – fall back to just the error bit
          message = errorBit;
          if (!/[.!?]$/.test(message)) message += '.';
        }
      }

      // Case 3: fall back to message / errors fields
      if (!message && typeof response?.message === 'string') {
        message = response.message;
      } else if (!message && response?.errors) {
        const firstError = Object.values(response.errors)[0];
        if (Array.isArray(firstError)) {
          message = firstError[0];
        } else if (typeof firstError === 'string') {
          message = firstError;
        }
      }

      // Ultimate fallback for anything weird
      if (!message || typeof message !== 'string') {
        message = 'Please check the recipient details and try again.';
      }

      return message;
    }

        getFieldLabelText(rawFieldName) {
      if (!rawFieldName || !this.form) return null;

      let input = null;

      // Try to find the input by its "name" attribute (e.g. properties[Recipient email])
      try {
        input = this.form.querySelector(`[name="${rawFieldName}"]`);
      } catch (e) {
        input = null;
      }

      if (input && input.id) {
        const id = input.id;
        const labels = this.form.querySelectorAll('label');
        for (let i = 0; i < labels.length; i++) {
          if (labels[i].htmlFor === id) {
            return labels[i].textContent || labels[i].innerText;
          }
        }
      }

      // Heuristics if we didn’t find a label, tuned for your gift-card fields
      const key = String(rawFieldName).toLowerCase();
      if (key.includes('email')) return 'Recipient email';
      if (key.includes('name')) return 'Recipient name';
      if (key.includes('message')) return 'Message';
      if (key.includes('date') || key.includes('send')) return 'Send on';

      return null;
    }



    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
